/**
 * Marker 선택 Modal
 */
import { _ } from 'core-js'

export default {
  name: 'BriqueChartModalMarkerSymbol',
  inheritAttrs: false, // 부모 Component에서 지정한 Element 속성을 무시 - vue 파일의 다음 구분 참조(v-bind="$attrs", v-on="$listeners"
  props: {
    visible: {
      type: Boolean,
      default: true,
      required: false
    },
    parentChartData: {
      type: Array,
      required: true
    },
    seriesName: {
      type: String,
      default: '',
      required: true
    },
    beforeSymbol: {
      type: String,
      default: '',
      required: true
    },
    beforeSize: {
      type: Number,
      default: 3,
      required: true
    }
  },
  computed: {
  },
  methods: {
    /**
     * 확인 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     */
    onClickConfirmButton (returnObject) {
      this.$emit('click-confirm-button-in-modal-marker-symbol', returnObject, this.seriesName, this.data)
    },

    /**
     * 취소 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     */
    onClickCancelButton (returnObject) {
    }
  }, // end - methods
  created () {
  },
  watch: {
    tabStep (strTabStep) {
      this.data.tabStep = this.tabSteps.indexOf(strTabStep)
    },
    visible () {
      if (this.visible === false) return
      this.data.symbol = _.isEmpty(this.beforeSymbol) ? 'none' : this.beforeSymbol
      this.data.size = this.beforeSize
    },
    'data.size' (val) {
      if (_.isString(val)) this.data.size = Number(val)
    }
  },
  data () {
    return {
      data: {
        symbol: '',
        size: 6
      },
      symbols: [ // FIXME: none 이외의 다른 항목들에 대한 다국어 처리 필요할 때 넣을 것 (현재 label은 none만 사용)
        {
          name: 'none',
          label: this.$t('fdc.CHART_COMPONENT.LABEL.NONE'),
          path: '',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'circle',
          // label: 'circle', // 다국어 처리할 것
          path: 'M5,0A5,5 0 1,1 0,-5A5,5 0 0,1 5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'circle-open',
          // label: 'circle-open', // 다국어 처리할 것
          path: 'M5,0A5,5 0 1,1 0,-5A5,5 0 0,1 5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'circle-open-dot',
          // label: 'circle-open-dot', // 다국어 처리할 것
          path: 'M5,0A5,5 0 1,1 0,-5A5,5 0 0,1 5,0ZM0,0.5L0.5,0L0,-0.5L-0.5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'square',
          // label: 'square', // 다국어 처리할 것
          path: 'M5,5H-5V-5H5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'square-open',
          // label: 'square-open', // 다국어 처리할 것
          path: 'M5,5H-5V-5H5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'square-open-dot',
          // label: 'square-open-dot', // 다국어 처리할 것
          path: 'M5,5H-5V-5H5ZM0,0.5L0.5,0L0,-0.5L-0.5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'diamond',
          // label: 'diamond', // 다국어 처리할 것
          path: 'M6.5,0L0,6.5L-6.5,0L0,-6.5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'diamond-open',
          // label: 'diamond-open', // 다국어 처리할 것
          path: 'M6.5,0L0,6.5L-6.5,0L0,-6.5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'diamond-open-dot',
          // label: 'diamond-open-dot', // 다국어 처리할 것
          path: 'M6.5,0L0,6.5L-6.5,0L0,-6.5ZM0,0.5L0.5,0L0,-0.5L-0.5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'cross',
          // label: 'cross', // 다국어 처리할 것
          path: 'M6,2H2V6H-2V2H-6V-2H-2V-6H2V-2H6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'cross-open',
          // label: 'cross-open', // 다국어 처리할 것
          path: 'M6,2H2V6H-2V2H-6V-2H-2V-6H2V-2H6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'x',
          // label: 'x', // 다국어 처리할 것
          path: 'M0,2.83l2.83,2.83l2.83,-2.83l-2.83,-2.83l2.83,-2.83l-2.83,-2.83l-2.83,2.83l-2.83,-2.83l-2.83,2.83l2.83,2.83l-2.83,2.83l2.83,2.83Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'x-open',
          // label: 'x-open', // 다국어 처리할 것
          path: 'M0,2.83l2.83,2.83l2.83,-2.83l-2.83,-2.83l2.83,-2.83l-2.83,-2.83l-2.83,2.83l-2.83,-2.83l-2.83,2.83l2.83,2.83l-2.83,2.83l2.83,2.83Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'triangle-up',
          // label: 'triangle-up', // 다국어 처리할 것
          path: 'M-5.77,2.5H5.77L0,-5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'triangle-up-open',
          // label: 'triangle-up-open', // 다국어 처리할 것
          path: 'M-5.77,2.5H5.77L0,-5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'triangle-down',
          // label: 'triangle-down', // 다국어 처리할 것
          path: 'M-5.77,-2.5H5.77L0,5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'triangle-down-open',
          // label: 'triangle-down-open', // 다국어 처리할 것
          path: 'M-5.77,-2.5H5.77L0,5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'triangle-left',
          // label: 'triangle-left', // 다국어 처리할 것
          path: 'M2.5,-5.77V5.77L-5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'triangle-left-open',
          // label: 'triangle-left-open', // 다국어 처리할 것
          path: 'M2.5,-5.77V5.77L-5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'triangle-right',
          // label: 'triangle-right', // 다국어 처리할 것
          path: 'M-2.5,-5.77V5.77L5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'triangle-right-open',
          // label: 'triangle-right-open', // 다국어 처리할 것
          path: 'M-2.5,-5.77V5.77L5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'triangle-ne',
          // label: 'triangle-ne', // 다국어 처리할 것
          path: 'M-6,-3H3V6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'triangle-ne-open',
          // label: 'triangle-ne-open', // 다국어 처리할 것
          path: 'M-6,-3H3V6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'triangle-se',
          // label: 'triangle-se', // 다국어 처리할 것
          path: 'M3,-6V3H-6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'triangle-se-open',
          // label: 'triangle-se-open', // 다국어 처리할 것
          path: 'M3,-6V3H-6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'triangle-sw',
          // label: 'triangle-sw', // 다국어 처리할 것
          path: 'M6,3H-3V-6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'triangle-sw-open',
          // label: 'triangle-sw-open', // 다국어 처리할 것
          path: 'M6,3H-3V-6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'triangle-nw',
          // label: 'triangle-nw', // 다국어 처리할 것
          path: 'M-3,6V-3H6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'triangle-nw-open',
          // label: 'triangle-nw-open', // 다국어 처리할 것
          path: 'M-3,6V-3H6Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'pentagon',
          // label: 'pentagon', // 다국어 처리할 것
          path: 'M4.76,-1.54L2.94,4.05H-2.94L-4.76,-1.54L0,-5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'pentagon-open',
          // label: 'pentagon-open', // 다국어 처리할 것
          path: 'M4.76,-1.54L2.94,4.05H-2.94L-4.76,-1.54L0,-5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'hexagon',
          // label: 'hexagon', // 다국어 처리할 것
          path: 'M4.33,-2.5V2.5L0,5L-4.33,2.5V-2.5L0,-5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'hexagon-open',
          // label: 'hexagon-open', // 다국어 처리할 것
          path: 'M4.33,-2.5V2.5L0,5L-4.33,2.5V-2.5L0,-5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'hexagon2',
          // label: 'hexagon2', // 다국어 처리할 것
          path: 'M-2.5,4.33H2.5L5,0L2.5,-4.33H-2.5L-5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'hexagon2-open',
          // label: 'hexagon2-open', // 다국어 처리할 것
          path: 'M-2.5,4.33H2.5L5,0L2.5,-4.33H-2.5L-5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'octagon',
          // label: 'octagon', // 다국어 처리할 것
          path: 'M-1.92,-4.62H1.92L4.62,-1.92V1.92L1.92,4.62H-1.92L-4.62,1.92V-1.92Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'octagon-open',
          // label: 'octagon-open', // 다국어 처리할 것
          path: 'M-1.92,-4.62H1.92L4.62,-1.92V1.92L1.92,4.62H-1.92L-4.62,1.92V-1.92Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'star',
          // label: 'star', // 다국어 처리할 것
          path: 'M1.58,-2.16H6.66L2.54,0.83L4.12,5.66L0,2.67L-4.12,5.66L-2.54,0.83L-6.66,-2.16H-1.58L0,-7Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'star-open',
          // label: 'star-open', // 다국어 처리할 것
          path: 'M1.58,-2.16H6.66L2.54,0.83L4.12,5.66L0,2.67L-4.12,5.66L-2.54,0.83L-6.66,-2.16H-1.58L0,-7Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'hexagram',
          // label: 'hexagram', // 다국어 처리할 것
          path: 'M-3.8,0l-1.9,-3.3h3.8l1.9,-3.3l1.9,3.3h3.8l-1.9,3.3l1.9,3.3h-3.8l-1.9,3.3l-1.9,-3.3h-3.8Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'hexagram-open',
          // label: 'hexagram-open', // 다국어 처리할 것
          path: 'M-3.8,0l-1.9,-3.3h3.8l1.9,-3.3l1.9,3.3h3.8l-1.9,3.3l1.9,3.3h-3.8l-1.9,3.3l-1.9,-3.3h-3.8Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'star-triangle-up',
          // label: 'star-triangle-up', // 다국어 처리할 것
          path: 'M-6.93,4A 20,20 0 0 1 6.93,4A 20,20 0 0 1 0,-8A 20,20 0 0 1 -6.93,4Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'star-triangle-up-open',
          // label: 'star-triangle-up-open', // 다국어 처리할 것
          path: 'M-6.93,4A 20,20 0 0 1 6.93,4A 20,20 0 0 1 0,-8A 20,20 0 0 1 -6.93,4Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'star-triangle-down',
          // label: 'star-triangle-down', // 다국어 처리할 것
          path: 'M6.93,-4A 20,20 0 0 1 -6.93,-4A 20,20 0 0 1 0,8A 20,20 0 0 1 6.93,-4Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'star-triangle-down-open',
          // label: 'star-triangle-down-open', // 다국어 처리할 것
          path: 'M6.93,-4A 20,20 0 0 1 -6.93,-4A 20,20 0 0 1 0,8A 20,20 0 0 1 6.93,-4Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'star-square',
          // label: 'star-square', // 다국어 처리할 것
          path: 'M-5.5,-5.5A 10,10 0 0 1 -5.5,5.5A 10,10 0 0 1 5.5,5.5A 10,10 0 0 1 5.5,-5.5A 10,10 0 0 1 -5.5,-5.5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'star-square-open',
          // label: 'star-square-open', // 다국어 처리할 것
          path: 'M-5.5,-5.5A 10,10 0 0 1 -5.5,5.5A 10,10 0 0 1 5.5,5.5A 10,10 0 0 1 5.5,-5.5A 10,10 0 0 1 -5.5,-5.5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'star-diamond',
          // label: 'star-diamond', // 다국어 처리할 것
          path: 'M-7,0A 9.5,9.5 0 0 1 0,7A 9.5,9.5 0 0 1 7,0A 9.5,9.5 0 0 1 0,-7A 9.5,9.5 0 0 1 -7,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'star-diamond-open',
          // label: 'star-diamond-open', // 다국어 처리할 것
          path: 'M-7,0A 9.5,9.5 0 0 1 0,7A 9.5,9.5 0 0 1 7,0A 9.5,9.5 0 0 1 0,-7A 9.5,9.5 0 0 1 -7,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'diamond-tall',
          // label: 'diamond-tall', // 다국어 처리할 것
          path: 'M0,7L3.5,0L0,-7L-3.5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'diamond-tall-open',
          // label: 'diamond-tall-open', // 다국어 처리할 것
          path: 'M0,7L3.5,0L0,-7L-3.5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'diamond-wide',
          // label: 'diamond-wide', // 다국어 처리할 것
          path: 'M0,3.5L7,0L0,-3.5L-7,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'diamond-wide-open',
          // label: 'diamond-wide-open', // 다국어 처리할 것
          path: 'M0,3.5L7,0L0,-3.5L-7,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'hourglass',
          // label: 'hourglass', // 다국어 처리할 것
          path: 'M5,5H-5L5,-5H-5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'bowtie',
          // label: 'bowtie', // 다국어 처리할 것
          path: 'M5,5V-5L-5,5V-5Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: rgb(13, 118, 191);'
        },
        {
          name: 'cross-thin-open',
          // label: 'cross-thin-open', // 다국어 처리할 것
          path: 'M0,7V-7M7,0H-7',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'x-thin-open',
          // label: 'x-thin-open', // 다국어 처리할 것
          path: 'M5,5L-5,-5M5,-5L-5,5',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'asterisk-open',
          // label: 'asterisk-open', // 다국어 처리할 것
          path: 'M0,6V-6M6,0H-6M4.25,4.25L-4.25,-4.25M4.25,-4.25L-4.25,4.25',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'hash-open',
          // label: 'hash-open', // 다국어 처리할 것
          path: 'M2.5,5V-5m-5,0V5M5,2.5H-5m0,-5H5',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'hash-open-dot',
          // label: 'hash-open-dot', // 다국어 처리할 것
          path: 'M2.5,5V-5m-5,0V5M5,2.5H-5m0,-5H5M0,0.5L0.5,0L0,-0.5L-0.5,0Z',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'y-up-open',
          // label: 'y-up-open', // 다국어 처리할 것
          path: 'M-6,4L0,0M6,4L0,0M0,-8L0,0',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'y-down-open',
          // label: 'y-down-open', // 다국어 처리할 것
          path: 'M-6,-4L0,0M6,-4L0,0M0,8L0,0',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'y-left-open',
          // label: 'y-left-open', // 다국어 처리할 것
          path: 'M4,6L0,0M4,-6L0,0M-8,0L0,0',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'y-right-open',
          // label: 'y-right-open', // 다국어 처리할 것
          path: 'M-4,6L0,0M-4,-6L0,0M8,0L0,0',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'line-ew-open',
          // label: 'line-ew-open', // 다국어 처리할 것
          path: 'M7,0H-7',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'line-ns-open',
          // label: 'line-ns-open', // 다국어 처리할 것
          path: 'M0,7V-7',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'line-ne-open',
          // label: 'line-ne-open', // 다국어 처리할 것
          path: 'M5,-5L-5,5',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        },
        {
          name: 'line-nw-open',
          // label: 'line-nw-open', // 다국어 처리할 것
          path: 'M5,5L-5,-5',
          style: 'stroke: rgb(13, 118, 191); stroke-opacity: 1; stroke-width: 2px; fill: none;'
        }
      ]
    } // end - data return
  } // end-data
}
